import { EventEmitter } from 'fbemitter';

const _heartbeat = new EventEmitter();

setInterval(() => {
  _heartbeat.emit('beat');
}, 1000);

export default callback => _heartbeat.addListener('beat', callback);




// WEBPACK FOOTER //
// ./src/utils/heartbeat.js